import edit_reminder from './edit-reminder.json';
import edit_reminder_success_modal from './edit-reminder-success-modal.json';

export default {
  'edit-reminder': {
    ...edit_reminder,
    ...edit_reminder_success_modal,
  },
};
